// extracted by mini-css-extract-plugin
export default {"containter":"first_containter__dI8VX","icon":"first_icon__zPtVa"};